import { createFileRoute } from "@tanstack/react-router";
import { PerformanceMarketingServicePage } from "./services_.performance-marketing";

export const Route = createFileRoute("/services_/performance-marketing-services")({
  head: () => ({
    meta: [
      {
        title: "Performance Marketing Services — KMWAdvertising",
      },
      {
        name: "description",
        content: "High-ROI Performance Marketing Campaigns across Google, Meta & LinkedIn.",
      },
    ],
  }),
  component: PerformanceMarketingServicePage,
});
